<div class="main-container">

  <div class="main-title" data-cy="patient-portal-request-appointment-title">
    Appointment request for {{data.date}}
  </div>

  <div class="reason-input">
    <div data-cy="patient-portal-request-appointment-reason-label">Please provide a reason for the requested appointment:</div>
    <div style="flex: 1; padding: 4px; background-color: rgba(0, 0, 0, 0.05); border-radius: var(--border-radius);">
      <textarea placeholder="Type your reason here..."
        style="height: 120px; width: 100%; outline: unset; border: unset; resize: none; background-color: unset;"
        [(ngModel)]="reasonText" data-cy="patient-portal-request-appointment-reason-input"></textarea></div>
      
  </div>

  <div class="action-container">
    <button mat-button class="action-button tdo-close" color="warn" (click)="close(false)" data-cy="patient-portal-request-appointment-cancel-button">Cancel</button>
    <button mat-raised-button class="action-button tdo-save" color="primary" (click)="close(true)"
      [disabled]="!reasonText" data-cy="patient-portal-request-appointment-confirm-button">Confirm</button>
  </div>

</div>